/* eslint-disable no-unsafe-optional-chaining */
import { extendableComponent } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { Rating } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import useCallAPI from '../../hooks/useCallAPI'
import { CategoryReviewItemTabs } from './CategoryReviewItemTabs'
import { ProductReviewsImageList } from './ProductReviewsImageList'
import ReviewChart, { BarChartValues } from './ReviewChart'
import { ReviewItemProps } from './ReviewItem'
import { ReviewItemTabs } from './ReviewItemTabs'

export type CategoryReviewsProps = {
  reviews: Array<any> | null | undefined
  averageScoreRouned: number
  reviewsCount?: number
  reviewsAverageScore?: number
  customer: any | undefined
}

export function CategoryReviews(props: CategoryReviewsProps) {
  const { reviews, averageScoreRouned, reviewsCount, reviewsAverageScore } = props
  const name = 'ImageText' as const
  const parts = ['root'] as const
  const { classes } = extendableComponent(name, parts)

  // Generate chart values from reviews
  const chartValues = useMemo(() => {
    const values: BarChartValues = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }

    reviews?.forEach((review) => {
      const score = review?.score
      if (score && score >= 1 && score <= 5) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const roundedScore = Math.round(score) as 1 | 2 | 3 | 4 | 5
        values[roundedScore]++
      }
    })

    return values
  }, [reviews])

  return (
    <div className={`${classes.root}`}>
      {(!reviewsCount || reviewsCount < 1) && (
        <div className='Type-XXXL-Regular mx-[20px] my-[40px] flex w-full flex-col items-start justify-center lg:my-[80px]'>
          <span className='lg:Type-XL-Regular Type-Large-Regular'>
            <Trans id='Although this product does not yet have reviews, this supplier has been approved by Templi and orders have been processed for this product with favorable results.' />
          </span>
        </div>
      )}
      {reviewsCount && reviewsCount > 0 && (
        <div className='mx-5 md:mx-0 gap-10 lg:grid lg:grid-cols-[30fr_70fr]'>
          <div>
            <span className='Type-XXXL-Medium text-black'>
              <Trans id='Reviews' />
            </span>
            <div className='Type-Base-Medium gap-y-3 lg:Type-Large-Medium ml-[-8px] mt-5 md:mt-10 pb-5 text-black lg:flex-row flex-col flex lg:items-center'>
              <Rating
                name='total-ratings'
                defaultValue={averageScoreRouned}
                size='large'
                readOnly
                precision={0.1}
                className='px-2 align-bottom'
              />
              <span className='Type-XL-Regular flex items-center ml-[12px]'>
                ({averageScoreRouned})
                <div className='md:hidden xl:block ml-1'>{`${reviewsCount} Reviews`}</div>
              </span>
            </div>
            <ReviewChart values={chartValues ?? {}} />
            {/* <div className='Type-XXXL-Medium mb-5 hidden text-70-grey'>
              <span className='Type-H4-Bold text-parks-green lg:block'>
                {(reviewsData?.bottomline?.average_score / 5) * 100}%
              </span>{' '}
              <div className='inline lg:block'>
                <Trans id='Would order again' />
              </div>
            </div> */}
            {/* {reviewsData?.images && reviewsData?.images?.length > 0 && (
              <ProductReviewsImageList images={reviewsData?.images} className='mb-20' />
            )} */}
          </div>
          {reviews && reviews?.length > 0 && (
            <div className='mt-8 md:mt-0'>
              <div className='pb-5'>
                <CategoryReviewItemTabs reviews={reviews} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
